import React, { useEffect, useRef } from 'react';
import uuid from 'uuid-random';

import { scrollService } from '@core/js/services/scroll.service';

import style from '@core/js/components/common/Overlay/Overlay.scss';

export const Overlay = ({ className = '', customLockId = false, ...props }) => {
    const lockIdRef = useRef(uuid());

    useEffect(() => {
        const lockId = lockIdRef.current;

        if (!customLockId) {
            scrollService.disableBodyScroll(lockId);
        }

        return () => {
            if (customLockId) {
                scrollService.enableBodyScroll(customLockId);
            }

            scrollService.enableBodyScroll(lockId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div className={`${style.overlay} ${className}`} {...props} />;
};

export default Overlay;
